import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import useStyles from './style';

const SettingsItem: FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  return <div className={classNames('settingsItem', classes.settingsItem)}>{children}</div>;
};

export default SettingsItem;
